/**
 * Defines supported region types.
 */
export enum RegionDataType {
    Point = "point",
    Rect = "rect",
    Polyline = "polyline",
    Polygon = "polygon",
    Path = "Path",
}
